import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
})

export type TanstackProviderProps = React.PropsWithChildren

export const TanstackProvider = ({ children }: TanstackProviderProps) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
)
